import { Construction } from "lucide-react";

export default function ComingSoon({ title = "Coming Soon", description }) {
  return (
    <div className="section-panel" data-testid="coming-soon-panel">
      <div style={{ padding: "56px 24px", textAlign: "center", maxWidth: 440, margin: "0 auto" }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: 16,
            background: "var(--brand-light)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 16,
          }}
        >
          <Construction size={28} color="var(--brand-dark)" />
        </div>
        <div className="section-title" style={{ fontSize: 18, marginBottom: 8 }}>{title}</div>
        <p style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6, margin: 0 }}>
          {description || "This feature is under development and will be available soon."}
        </p>
        <div
          className="badge pending"
          style={{ marginTop: 18, display: "inline-block", fontSize: 11 }}
        >
          Coming Soon
        </div>
      </div>
    </div>
  );
}
